import React, { Component } from 'react';
import styled from 'styled-components';

import css from 'css';
import WP from 'WP';
import Loader from 'partials/Loader';
import { Button } from 'partials/formElements';
import Paperclip from 'images/Paperclip';
import RemoveIcon from 'images/RemoveIcon';
import { trunclate, msg } from 'helpers';

class FileUploader extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            error: null,
            uploading: false,
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    _onSelectFileClick() {
        this.refs.file.click();
    }

    _onFileInputChange(e) {
        const { maxFileSizeInBytes } = this.props;
        const file = e.target.files[0];

        this.setState({ error: null });

        if(file.size > (maxFileSizeInBytes || WP.max_upload_size)) {
            this.setState({ error: msg('fileMaxSizeError')+' '+ Math.floor((maxFileSizeInBytes || WP.max_upload_size)/1000000)+'MB' });
            return;
        }

        // Read the file inline as base64 and hand it to the parent; attachments are
        // submitted together with the booking rather than stored via a server upload endpoint.
        const fileName = file.name;
        const reader  = new FileReader();

        reader.addEventListener('load', () => {
            const file = reader.result.split(',')[1];
            this.props.onChange([...this.props.files, { fileName, file }]);
        }, false);

        reader.readAsDataURL(file);
    }

    _onRemoveFileClick(file) {
        // remove file (matched by name) from the "files" list (available via prop) and emit change
        this.props.onChange(this.props.files.filter(f => f.fileLink !== file.fileLink));
    }
  
    render() {
        const { error, uploading } = this.state;
        const { buttonLabel, files, accept, maxFiles } = this.props;

        //console.log(files);

        return (
            <FileUpload>

                <div className="error">{error}</div>

                {uploading && <Loader color={css.colors.blue} />}

                {files.map((file, i) => {
                    return(
                        <div className="file-info" key={i}>
                            {trunclate(file.fileName, 30, '...', true)}
                            <RemoveIcon onClick={() => this._onRemoveFileClick(file)} />
                        </div>
                    )
                })}

                {files.length < (maxFiles || 5) &&
                    <div className="select-button">
                        <Button outline blue onClick={this._onSelectFileClick.bind(this)}>{buttonLabel || 'Select file'}</Button>   
                        <Paperclip /> 
                    </div>
                }

                <form>
                    <input ref="file" type="file" accept={accept || 'image/*'} onChange={this._onFileInputChange.bind(this)} />
                </form>

            </FileUpload>
        );
    }
}

export default FileUploader;

const FileUpload = styled.div`
    margin:40px 0;
    width:100%;
    text-align:center;
    .error {
        color: ${css.colors.red};
        margin-bottom: 10px;
    }
    .loader {
        margin-bottom: 10px;
    }
    .file-info {
        width: 280px;
        margin: 0 auto 10px;
        position:relative;
        svg {
            position: absolute;
            top: 50%;
            right: 0px;
            transform: translateY(-50%);
            cursor: pointer;
        }
    }
    .select-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 40px;
        button {
            width:220px;
            color: #fff;
        }
        svg {
            margin-left: 12px;
        }
    }
    form {
        width: 0;
        height:0;
        overflow: hidden;
    }
`


// WEBPACK FOOTER //
// ./src/partials/formElements/FileUploader.js